import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { LoginHeaderComponent } from './components/login-header/login-header.component';
import { LoginNoticeComponent } from './components/login-notice/login-notice.component';
import { LoginFormComponent } from './components/login-form/login-form.component';
import { LoginHeroComponent } from './components/login-hero/login-hero.component';
import { LoginProvidersComponent } from './components/login-providers/login-providers.component';
import { LoginDialogComponent } from './components/login-dialog/login-dialog.component';
import { LoginPoweredByComponent } from './components/login-powered-by/login-powered-by.component';
import { LoginPagePreviewComponent } from './login-page-preview/login-page-preview.component';

const LOGIN_UI = [
  LoginHeaderComponent,
  LoginNoticeComponent,
  LoginFormComponent,
  LoginHeroComponent,
  LoginProvidersComponent,
  LoginDialogComponent,
  LoginPoweredByComponent,
  LoginPagePreviewComponent,
];

@NgModule({
  imports: [CommonModule, FormsModule],
  declarations: LOGIN_UI,
  exports: LOGIN_UI,
})
export class LoginUiModule {}
